import { connect } from 'react-redux'
import WishlistLabel from './WishlistLabel'
import { actions as wishlistActions } from 'Participant/Wishlist'

const mapStateToProps = ({ wishlist: { groupedWishlistBySkuId } }) => ({
  groupedWishlistBySkuId
})

const mapDispatchToProps = dispatch => ({
  toggleWishlist: (isInWishlist, sku) => () => isInWishlist
    ? dispatch(wishlistActions.addWishlist(sku))
    : dispatch(wishlistActions.removeWishlist(sku))
})

const mergeProps = ({ groupedWishlistBySkuId }, dispatchProps, { sku }) => {
  const isInWishlist = groupedWishlistBySkuId && !!groupedWishlistBySkuId[sku]
  const toggleWishlist = dispatchProps.toggleWishlist(isInWishlist, sku)

  return { isInWishlist, toggleWishlist }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(WishlistLabel)



// WEBPACK FOOTER //
// ./src/features/Availability/ProductCard/WishlistLabel/WishlistLabelContainer.js